/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Input from "../common/Input";
import { calculateDisplayedErrors } from "../common/Helpers";
import { useTranslation } from 'react-i18next';

function LoginForm({
  username,
  password,
  touched,
  errors,
  onBlur,
  onChange,
  onSubmit,
  onCancel,
  disabled,
  status,
  ssoButton,
}) {
  const { t: tr } = useTranslation();
  const err = calculateDisplayedErrors(errors, touched, status);
  return (
    <div className="quiz-text">
      <h2><strong>{tr("auth:loginHeading")}</strong></h2>
      <form id="client-form" onSubmit={onSubmit}>

        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input label={tr("auth:userEmail")} onBlur={onBlur} onChange={onChange} name="username" value={username} error={err.username} placeholder={tr("auth:user")} />
          </div>
        </div>

        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input label={tr("common:password")} type="password" onBlur={onBlur} onChange={onChange} name="password" value={password} error={err.password} placeholder={tr("common:password")} />
          </div>
        </div>


        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Link to="/manage/password-reset">{tr("auth:forgotPassword")}</Link>
            <span className="mx-2">|</span>
            <Link to="/account/signup">{tr("auth:firstLogin")}</Link>
          </div>
        </div>

        <div className="row">
          <div className="col-md-2 mb-2">
            <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={disabled}>{tr("auth:login")}</button>
          </div>
          <div className="col-md-2">
            <button type="button" className="btn manage-button manage-teal-button btn-block" onClick={onCancel} disabled={disabled}>{tr("common:cancel")}</button>
          </div>
        </div>
      </form>

      {ssoButton && (
        <>
          <div className="mt-3 mb-2"><strong>{tr("common:or")}</strong></div>
          <div className="row">
            <div className="col-md-4 col-lg-3">
              {ssoButton}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

LoginForm.propTypes = {
  username: PropTypes.string,
  password: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  ssoButton: PropTypes.node,
};

LoginForm.defaultProps = {
  username: "",
  password: "",
  disabled: false,
  ssoButton: null,
};

export default LoginForm;
